import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import type { ComponentType, ReactNode } from 'react'

import AdminLayout from './layouts/admin-layout'
import AdminDashboardIndex from './pages/admin/dashboard/index'

type InertiaPageComponent = ComponentType<any> & {
  layout?: (page: ReactNode) => ReactNode
}

const pages: Record<string, InertiaPageComponent> = {
  'admin/dashboard/index': AdminDashboardIndex,
}

createInertiaApp({
  resolve: (name) => {
    const page = pages[name]

    if (!page) {
      throw new Error(`Unknown Inertia page: ${name}`)
    }

    page.layout ??= (node: ReactNode) => <AdminLayout>{node}</AdminLayout>

    return page
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
  title: (title) => (title ? `${title} · godere` : 'godere admin'),
})
